import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { debounce } from 'lodash'

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

store.watch(
  (state) => state.selectedVideoBradingOption,
  debounce(function () {
    store.dispatch('saveVideoBrandingPreset')
  }, 250),
  { deep: true }
)

export default store
